export default class IconAnimation {
	private container : Element;
	private items : NodeListOf<Element>;
	private count : number;
	private index : number;

	private update(that: IconAnimation){
		that.index = (that.index === that.count - 1) ? 0 : (that.index + 1);

		for (let i = 0, l = that.count; i<l; ++i){
			if (i == that.index) {
				(that.items[i]).classList.add('active');
			} else {
				(that.items[i]).classList.remove('active');
			}
		}
	}
	constructor(variables: any) {
		this.container = document.querySelector('.iconAnimation');
		if (this.container == null) return;
		this.items = this.container.querySelectorAll('img');
		this.count = this.container.querySelectorAll('img').length;
		this.index = 0;
		(this.items[0]).classList.add('active');

		let intervalID = window.setInterval(this.update, variables.iconAnimationDuration, this);
	}
}
